/** Namespace `einvoiceAgency` — EINV-2026-020 GĐ7: « E-invoice agency » page (agency channel via bube-einvoice). */
export const einvoiceAgency = {
  title: "E-invoice agency",
  subtitle: "{product} · {env}",
  intro:
    "Bube is the provider's AGENT: create customer accounts + invoice packages, add / revoke invoice quantity, renew, suspend, update contacts. Commands run in bube-einvoice with the agency credential set ASSIGNED in the hub; every operation has an idempotency key — retrying never provisions twice.",
  notAgency: "This service has no agency channel in the catalog.",
  readOnlyRole: "Your role is read-only — agency operations need the integrations write permission.",
  envSandbox: "Sandbox (demo)",
  envLive: "Live",
  commercialTitle: "Bube's selling right",
  commercialIntro:
    "Having an agency API ≠ being allowed to sell. « Buy through Bube » and live agency operations open only when the selling right is « Active ». Changes here take effect immediately (the hub pushes the config to the apps), no deploy needed.",
  "status.unverified": "Unverified",
  "status.negotiating": "Negotiating",
  "status.active": "Active",
  "status.suspended": "Suspended",
  "status.expired": "Expired",
  effectiveStatus: "Effective status",
  statusField: "Selling right status",
  contractRef: "Contract no.",
  effectiveFrom: "Effective from",
  effectiveUntil: "Effective until",
  note: "Note",
  save: "Save selling right",
  saved: "Selling right saved. Config push status per app is below.",
  updatedBy: "Updated {at} by {by}",
  neverSet: "Not set — defaults to « Unverified ».",
  operationTitle: "Operation",
  "op.account_create": "Create customer + package",
  "op.quota_adjust": "Add / revoke quantity",
  "op.renew": "Renew",
  "op.suspend": "Suspend",
  "op.contact_update": "Update contact",
  "direction.outbound": "Sales",
  "direction.inbound": "Purchase",
  customerName: "Customer name",
  taxCode: "Tax code",
  address: "Address",
  email: "Email",
  phone: "Phone",
  fax: "Fax",
  years: "Years",
  quantity: "Quantity (negative = revoke)",
  services: "Service packages",
  directions: "Invoice types",
  confirmLive: "Live: retype the customer's tax code to confirm the real operation",
  run: "Send command",
  running: "Sending…",
  failed: "Could not send: {error}",
  resultTitle: "Result",
  historyTitle: "Operation history",
  historyEmpty: "No operations in this environment yet.",
  historyFailed: "Could not load history: {error}",
  "result.succeeded": "Succeeded",
  "result.rejected": "Rejected",
  "result.unknown": "Unknown — reconcile",
  "result.pending": "Running",
  resultUnavailable: "The provider reported the key as already processed — the operation reached it, no result to show.",
  attempts: "{n} attempt(s)",
  traceId: "Trace ID: {id}",
  retry: "Retry with the same key",
  retryAt: "Retry available at {at}",
  createdAt: "At",
} as const;
